/* eslint-disable dot-notation */
import axios from 'axios'
import { openLoginModal } from 'redux/actions/loginActions'
import store from 'redux/store'
import { algoliaHeaders, headers } from 'Utils/StageHandler'

export const aludraApi = axios.create({
  baseURL: process.env.REACT_APP_ALUDRA_API_BASE_URL,
})

export const algoliaApi = axios.create({
  baseURL: 'https://ZCZRBTYD8I-dsn.algolia.net/1/indexes/',
})

export const busApi = axios.create({
  baseURL: process.env.REACT_APP_ALUDRA_API_BASE_URL + '/documentbus',
})

export const documentBusApi = axios.create({
  baseURL: process.env.REACT_APP_API_DOCUMENT_BUS,
})

export const cuartApi = axios.create({
  baseURL: process.env.REACT_APP_CUART_API_BASE_URL,
})

export const oaApi = axios.create({
  baseURL: process.env.REACT_APP_ALUDRA_API_BASE_URL,
})

aludraApi.interceptors.request.use(config => {
  const token = store.getState().login.user?.AuthenticationInfo?.Token
  const apimKey = store.getState().login?.checkCompany[0]?.APIMSubscriptionKey
  const isSearchSaleOrderWeb = window.location.pathname.includes(
    '/buscar_orden_venta_web'
  )

  const subscriptionKey = process.env.REACT_APP_SUBSCRIPTION_KEY || apimKey
  const apiKey = process.env.REACT_APP_API_KEY

  if (token && apimKey) {
    headers['app-type'] = isSearchSaleOrderWeb ? 'AB' : 'VA'
    config.headers = {
      ...config.headers,
      ...headers,
      'Api-Key': apiKey,
      'Ocp-Apim-Subscription-Key': subscriptionKey,
      Authorization: `Bearer ${token}`,
      Accept: 'application/json',
    }
  }
  return config
})

algoliaApi.interceptors.request.use(config => {
  config.headers = {
    ...algoliaHeaders,
  }
  return config
})

busApi.interceptors.request.use(config => {
  const apiKey = process.env.REACT_APP_API_KEY
  config.headers = {
    'Api-Key': apiKey,
  }
  return config
})

let isRefreshing = false
let failedQueue = []

const processQueue = (error, token = null) => {
  failedQueue.forEach(promise => {
    if (error) {
      promise.reject(error)
    } else {
      promise.resolve(token)
    }
  })
  failedQueue = []
}

const apis = [aludraApi, algoliaApi, busApi, documentBusApi, cuartApi]

apis.forEach(api => {
  api.interceptors.response.use(
    response => response,
    error => {
      const originalRequest = error.config

      if (error.response?.status === 401 && !originalRequest._retry) {
        if (isRefreshing) {
          return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject })
          }).then(token => {
            originalRequest._retry = true
            originalRequest.headers['Authorization'] = `Bearer ${token}`

            return axios(originalRequest)
          })
        }

        isRefreshing = true
        store.dispatch(openLoginModal(true))

        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject })

          const unsubscribe = store.subscribe(() => {
            const token = store.getState().login.user?.AuthenticationInfo?.Token
            const loginCanceled = store.getState().login.isLoginModal

            if (token && !loginCanceled) {
              unsubscribe()
              isRefreshing = false
              processQueue(null, token)
            } else if (!loginCanceled) {
              unsubscribe()
              isRefreshing = false
              processQueue(new Error('Login canceled'))
            }
          })
        }).then(token => {
          originalRequest._retry = true
          originalRequest.headers['Authorization'] = `Bearer ${token}`

          if (
            originalRequest.data &&
            typeof originalRequest.data === 'string'
          ) {
            try {
              originalRequest.data = JSON.parse(originalRequest.data)
            } catch (e) {
              console.warn('No se pudo parsear originalRequest.data:', e)
            }
          }

          originalRequest.headers['Content-Type'] = 'application/json'
          return axios(originalRequest)
        })
      }

      return Promise.reject(error)
    }
  )
})

oaApi.interceptors.request.use(config => {
  const token = store.getState().login.user?.AuthenticationInfo?.Token
  const apiKey = process.env.REACT_APP_API_KEY
  const subscriptionKey = process.env.REACT_APP_SUBSCRIPTION_KEY

  if (token) {
    config.headers = {
      ...config.headers,
      'Api-Key': apiKey,
      'Oocp-Apim-Subscription-Key': subscriptionKey,
      Accept: 'application/json',
    }
  }
  return config
})
